import React from "react"

import { FormContextProvider } from "../../contexts/formContext"

import { FormInputState } from "../../utils/validations"

import ProOrgDetailsForm from "./ProOrgDetailsForm"

interface Props {
  onComplete?: () => void
}
const ProOrgDetails = ({ onComplete }: Props) => {
  const intialFormInput: Record<string, FormInputState> = {
    organizationName: {
      value: "",
      label: "Organization Name",
      validation: [
        { type: "required" },
        { type: "min", value: 2 },
        { type: "max", value: 150 },
      ],
    },
    organizationType: {
      value: "",
      label: "Organization Type",
      validation: [
        { type: "required" },
        { type: "min", value: 2 },
        { type: "max", value: 150 },
      ],
    },
    organizationTypeOther: {
      value: "",
      label: "Other Type (please specify)",
      validation: [],
    },
    services: {
      value: [],
      label: "Services",
      validation: [{ type: "required" }],
    },
    servicesTypeOther: {
      value: "",
      label: "Other Services (please specify)",
      validation: [],
    },
  }

  return (
    <>
      <FormContextProvider initialInputs={intialFormInput}>
        <ProOrgDetailsForm onComplete={onComplete} />
      </FormContextProvider>
    </>
  )
}

export default ProOrgDetails
